import script from "./CommentAddReaction.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentAddReaction.vue?vue&type=script&setup=true&lang=js"

import "./CommentAddReaction.vue?vue&type=style&index=0&id=32efe7f1&lang=scss"

const __exports__ = script;

export default __exports__